import { forwardRef } from 'react';
// import IconFilters from './icon-filters.svg?react';
import { Filters as IconFilters } from '@elfsight/icons';
import { useFilters } from '../../../widget-filters-provider';
import type { BaseButtonProps } from '../../buttons';
import { BaseButton } from '../../buttons';

export type ModalTriggerButtonProps = Omit<
  BaseButtonProps,
  'rightSlot' | 'leftSlot' | 'selected' | 'badge'
>;

export const ModalTriggerButton = forwardRef<
  HTMLButtonElement,
  ModalTriggerButtonProps
>(({ children, onClick, ...forwardingProps }, forwardingRef) => {
  const { filtersAppliedCount } = useFilters();

  return (
    <BaseButton
      {...forwardingProps}
      badge={filtersAppliedCount}
      selected={filtersAppliedCount > 0}
      leftSlot={<IconFilters width={20} height={20} />}
      onClick={onClick}
      ref={forwardingRef}
    >
      {children}
    </BaseButton>
  );
});
